import React, { useMemo } from 'react';
import qs from "query-string";
import { useLocation } from 'react-router-dom';

import { ApplyOnlineForm } from "../../components/ApplyOnlineForm";
import { ApplyOnlinePayment } from "../../components/ApplyOnlinePayment";
import cn from "./ApplyOnline.module.scss";

export const ApplyOnline = () => {
  const { search } = useLocation();

  const queryParams = useMemo(() => qs.parse(search), [search]);
  const appNonce = useMemo(() => {
    return (queryParams.app_nonce || '').split(',');
  }, [queryParams]);

  const agencyNonce = useMemo(() => {
    return queryParams.agency_nonce;
  }, [queryParams]);

  return (
    <div className={cn.page}>
      <div className={cn.content}>
        {queryParams.action ? (
          <ApplyOnlinePayment appNonce={appNonce} />
        ) : (
          <ApplyOnlineForm agencyNonce={agencyNonce} />
        )}
      </div>
    </div>
  )
};
